// types
import { Transaction } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// headers
import { getSourcesHeaders } from './TableBasicNonCashBenefits.headers';

// ui
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';

// props
export interface TableBasicNonCashBenefitsProps extends Omit<TableProps, 'headers'> {
	data: Transaction[];
}

export const TableBasicNonCashBenefits = ({
	data = [],
	...props
}: TableBasicNonCashBenefitsProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const headers: TableHeader[] = getSourcesHeaders({ t });

	return <Table {...props} data={data} headers={headers} />;
};
